import React from "react";
import { Alert } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const RazlogBrisanjaComponent = ({ razlog }) => {
  return (
    <div style={{ margin: "16px 0" }}>
      <Alert
        message={"Razlog brisanja: " + `${razlog}`}
        type="error"
        icon={<DeleteOutlined />}
        showIcon
      />
    </div>
  );
};

export default RazlogBrisanjaComponent;
